(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vfd-engineering-selection"] && !Shopify.designMode) return;
  try {
    (()=>{
 function initialize(){document.querySelectorAll('form[data-guided-request]:not([data-ready])').forEach(form=>{
  form.dataset.ready='true';const messages=JSON.parse(form.querySelector('[data-request-messages]').textContent),review=form.querySelector('[data-request-review]'),email=form.querySelector('[data-request-email]'),status=form.querySelector('.vfd-request-status');
  function invalidate(){review.hidden=true;email.removeAttribute('href');status.textContent='';}
  form.querySelectorAll('[data-request-field]').forEach(field=>{
   const select=field.querySelector('select'),custom=field.querySelector('[data-custom]'),label=field.querySelector('[data-custom-label]');
   const update=()=>{const active=select.value==='custom'||(select.name==='replacement'&&select.value==='1');label.hidden=!active;custom.disabled=!active;custom.required=active;if(!active)custom.value='';invalidate();};
   select.addEventListener('change',update);update();
  });
  form.addEventListener('input',invalidate);
  form.addEventListener('submit',event=>{
   event.preventDefault();if(!form.reportValidity())return;
   const lines=[messages.drive+': '+form.dataset.model];
   form.querySelectorAll('[data-request-field]').forEach(field=>{const select=field.querySelector('select'),custom=field.querySelector('[data-custom]');lines.push(select.dataset.label+': '+select.options[select.selectedIndex].textContent+(!custom.disabled?' — '+custom.value.trim():''));});
   const notes=form.elements.namedItem('notes').value.trim();if(notes)lines.push(messages.notes+': '+notes);
   const body=lines.join('\n');form.querySelector('[data-request-summary]').textContent=body;email.href='mailto:sales@vfddirect.com?subject='+encodeURIComponent('Drive accessory selection: '+form.dataset.model)+'&body='+encodeURIComponent(body);review.hidden=false;status.textContent=messages.ready;review.querySelector('h3').focus();
  });
  email.addEventListener('click',()=>{status.textContent=messages.draft;});
 });}
 initialize();document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
